var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex flex-wrap justyfy-content-between" },
    [
      !_vm.items.length && !_vm.isFetching
        ? _c("h4", { staticClass: "m-3 font-16" }, [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$resourceString["common.noResults"]) +
                "\n  "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.items, function(hit) {
        return _c("div", { key: hit.colorNumber + "-" + hit.styleNumber }, [
          _c(
            "div",
            {
              staticClass: "result-wrapper",
              on: {
                mousedown: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "left", 37, $event.key, [
                      "Left",
                      "ArrowLeft"
                    ])
                  ) {
                    return null
                  }
                  if ("button" in $event && $event.button !== 0) {
                    return null
                  }
                  $event.preventDefault()
                  $event.stopPropagation()
                  return _vm.$emit("onResultClick", hit)
                },
                touchstart: function($event) {
                  return _vm.$emit("onResultClick", hit)
                }
              }
            },
            [
              _c("div", {
                staticClass: "result-img",
                style: [
                  hit.backgroundSlideImage
                    ? {
                        backgroundImage:
                          "url('" + hit.backgroundSlideImage + "')"
                      }
                    : { backgroundColor: hit.hexColor }
                ],
                attrs: {
                  slot: "item",
                  item: hit,
                  "data-bg": _vm.updateBackgroundAttributes(hit),
                  id: hit.colorNumber + "-" + hit.styleNumber,
                  "data-inventoryType": hit.inventoryType
                },
                slot: "item"
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "info-overlay p-2" },
                [
                  hit.inventoryType == "Carpet" ||
                  hit.inventoryType == "Resilient"
                    ? [
                        _vm._v("\n          " + _vm._s(hit.styleName)),
                        _c("br"),
                        _vm._v("\n          " + _vm._s(hit.styleNumber)),
                        _c("br"),
                        _vm._v(
                          "\n          " +
                            _vm._s(hit.colorName) +
                            " " +
                            _vm._s(hit.colorNumber)
                        ),
                        _c("br"),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-capitalize" }, [
                          _vm._v(_vm._s(hit.inventorySubType.toLowerCase()))
                        ])
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  hit.inventoryType.toUpperCase() == "POM"
                    ? [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$resourceString["virtualtray.pom"]) +
                            " " +
                            _vm._s(hit.colorNumber) +
                            "\n        "
                        )
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  hit.inventoryType == "Paint"
                    ? [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$resourceString["virtualtray.paint"]) +
                            " " +
                            _vm._s(hit.colorNumber) +
                            " " +
                            _vm._s(hit.colorName) +
                            "\n        "
                        )
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  hit.inventoryType == "Inspiration" ||
                  hit.inventoryType == "Premix"
                    ? [
                        _vm._v(
                          "\n          " + _vm._s(hit.colorName) + "\n        "
                        )
                      ]
                    : _vm._e()
                ],
                2
              )
            ]
          )
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }